import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Global } from "src/app/global";

@Component({
  selector: "app-modal-indicador-previne-brasil",
  templateUrl: "./modal-indicador-previne-brasil.component.html",
  styleUrls: ["./modal-indicador-previne-brasil.component.css"],
})
export class ModalIndicadorPrevineBrasilComponent implements OnInit {
  @Input() listaDeRegistros: any[];
  @Input() tipoIndicador: string;
  constructor(public global: Global, public bsModalRef: BsModalRef) {}

  ngOnInit() {    
  }
  limparCaracteresCidCiap(texto): string {
     if (texto !== undefined || texto.length > 2)
    return texto.slice(1, -1).replace(/\|/g, " - ");

    return " - ";
  }
}
